import React from "react";
import { Reveal } from "@/components/anim";
import { MANIFESTO } from "@/data/content";

export default function Manifesto() {
  return (
    <section id="platform" data-testid="manifesto-section" className="bg-bg-primary py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <p className="text-brand-teal text-xs font-bold uppercase tracking-[0.25em] mb-4">The Platform</p>
          <h2 className="font-heading text-4xl md:text-6xl font-medium tracking-tight text-ink leading-none max-w-3xl">
            A full-lifecycle water infrastructure company.
          </h2>
        </Reveal>

        <div className="mt-20 md:mt-28 flex flex-col">
          {MANIFESTO.map((c, i) => (
            <Reveal key={c.num} delay={0.05}>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-16 py-12 md:py-16 border-t border-brand-navy/15 items-start group">
                <div className="md:col-span-2 flex items-baseline gap-4">
                  <span className="font-accent italic text-5xl md:text-7xl text-brand-red">{c.num}</span>
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-heading text-2xl md:text-3xl font-medium text-ink tracking-tight">{c.title}</h3>
                  <p className="mt-2 font-accent italic text-lg text-brand-navy">{c.lead}</p>
                </div>
                <div className="md:col-span-6">
                  <p className="text-ink-soft text-base md:text-lg leading-relaxed">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
